module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/sp-txt-closed@3x-2fa653a6d6a729b648ec159d2ede1a29.png";